module.exports = __webpack_public_path__ + "img/hong_kong_2007.4af4974c.png";